import { render, staticRenderFns } from "./SocialShares.vue?vue&type=template&id=4dbb3ac5&"
import script from "./SocialShares.vue?vue&type=script&lang=js&"
export * from "./SocialShares.vue?vue&type=script&lang=js&"
import style0 from "./SocialShares.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports